import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from '@app/shared/services/auth.service';
import { VideoUploadDialogComponent } from '@app/videos/dialog/video-upload-dialog/video-upload-dialog.component';
import { VideosComponent } from '../videos/videos.component';

@Component({
  selector: 'app-contact-tabs',
  templateUrl: './contact-tabs.component.html',
  styleUrls: ['./contact-tabs.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ContactTabsComponent {
  tabIndex = 0;
  @ViewChild('videosComponent', ) videosComponent: VideosComponent | undefined;

  constructor(
    public matDialog: MatDialog,
    public authService: AuthService,
    private _router: Router,
  ) {}

  addVideo() {
    this.matDialog
      .open(VideoUploadDialogComponent, {
        data: {
          video: {},
        },
        width: '1200px',
        panelClass: ['-md', 'video-upload-dialog'],
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.videosComponent?.initializeVideos();
        }
      });
  }

  gotoDashboard() {
    this._router.navigateByUrl('/instrumententafel');
  }
}
